import { uri } from '../constants';

export const getGenres = async () => {
  try {
    const response = await fetch(`${uri}/genres`);
    if (!response.ok) throw new Error('Failed to fetch genres');
    return await response.json();
  } catch (error) {
    console.error('Error fetching genres:', error);
    throw error;
  }
};

export const createGenre = async (genreData) => {
  try {
    const response = await fetch(`${uri}/genres`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(genreData)
    });
    if (!response.ok) throw new Error('Failed to create genre');
    return await response.json();
  } catch (error) {
    console.error('Error creating genre:', error);
    throw error;
  }
};

export const updateGenre = async (genreId, genreData) => {
  try {
    const response = await fetch(`${uri}/genres/${genreId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(genreData)
    });
    if (!response.ok) throw new Error('Failed to update genre');
    return await response.json();
  } catch (error) {
    console.error('Error updating genre:', error);
    throw error;
  }
};

export const deleteGenre = async (genreId) => {
  try {
    const response = await fetch(`${uri}/genres/${genreId}`, {
      method: 'DELETE'
    });
    if (!response.ok) throw new Error('Failed to delete genre');
    return await response.json();
  } catch (error) {
    console.error('Error deleting genre:', error);
    throw error;
  }
};

export const getGenreById = async (genreId) => {
  try {
    const response = await fetch(`${uri}/genres/${genreId}`);
    if (!response.ok) throw new Error('Failed to fetch genre');
    return await response.json();
  } catch (error) {
    console.error('Error fetching genre:', error);
    throw error;
  }
};
